

exports.__esModule = true;
exports.$xoOnboardingSectionComponent = undefined;

var _uiRouter = require('uiRouter');

var _credit = require('xo-models/src/credit');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _checkout = require('xo-models/src/checkout');

var _guestThrottle = require('../guestThrottle');

var _paypalplus = require('../paypalplus');

require('xo-wallet-components/src/fi-logos/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoOnboardingSectionComponent = exports.$xoOnboardingSectionComponent = _squid.$Component.extend('$xoOnboardingSectionComponent', {
    tag: 'xo-onboarding-section',
    template: _template2['default'],
    scope: {
        token: '=?'
    },
    controller: ['$scope', function ($scope) {
        function throttleOnboardingFlow(flow) {
            return (0, _guestThrottle.$guestThrottle)(flow, $scope.token, _squid.$locale.lang, _squid.$locale.country, _squid.$meta.mfid);
        }

        $scope.signupThrottle = function () {
            if ($scope.forceCAPESignup) {
                _logger.$logger.info('redirecting_to_cape_acq_signup_throttle', {
                    showCapeCyco: $scope.showCapeCyco
                });

                return _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: $scope.showCapeCyco });
            } else {
                throttleOnboardingFlow('signup');
            }
        };

        $scope.guestThrottle = function () {
            throttleOnboardingFlow('guest');
        };

        function getFlowEligibility() {
            return _checkout.$FlowEligibilityModel.instance($scope.token).retrieve({
                params: {
                    'localeCountry': _squid.$locale.country
                }
            }).then(function (flowEligibility) {
                $scope.flowEligibility = flowEligibility;
            });
        }

        function getButtonLabelTreatment() {
            $scope.newUserVariant = false;
            $scope.newUserVariantWithText = false;

            return (0, _squid.$pxp)('xo_hermes_new_user', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermes_new_user_treatment_(a|b)', false, true).then(function (t) {
                if (t) {
                    $scope.newUserVariant = true;
                    if (t.treatment_name === 'xo_hermes_new_user_treatment_b') {
                        $scope.newUserVariantWithText = true;
                    }
                }
            });
        }

        function getPPCEZPTreatment() {
            $scope.showCapeCyco = false;

            return (0, _squid.$elmo)('xo_us_ppc_ezp', {
                'ctx.COUNTRY': $scope.checkoutAppData.get('merchant.merchant_country'),
                'ctx.merchantID': $scope.payee.get('merchant.id')
            }, 'Trmt_xo_us_ppc_.*', false, true).then(function (t) {
                if (t) {
                    if (t && t.treatment_name) {
                        $scope.showCapeCyco = true;
                    }
                }
            });
        }

        (0, _squid.$populate)($scope, {
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
            payee: _checkout.$CheckoutPayeeModel.instance($scope.token)
        }).then(function () {
            return getFlowEligibility();
        }).then(function () {
            return getPPCEZPTreatment();
        }).then(function () {
            return getButtonLabelTreatment();
        }).then(function () {
            var isPayPalCredit = $scope.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            $scope.creditDataModel = _credit.$CreditDataModel.instance($scope.token);
            $scope.forceCAPESignup = isPayPalCredit && !$scope.creditDataModel.payInFull;

            var useForcedSignupFlow = (0, _paypalplus.$isPayPalPlus)($scope.token) || $scope.forceCAPESignup;
            var guest = $scope.flowEligibility.guest;
            var signup = $scope.flowEligibility.signup;

            $scope.showGuestBtn = !useForcedSignupFlow && guest;
            $scope.showSignupBtn = useForcedSignupFlow || !guest && signup;
            $scope.hideOrSeparator = !$scope.showGuestBtn && !$scope.showSignupBtn;
        });
    }]
});

angular.value("$xoOnboardingSectionComponent", $xoOnboardingSectionComponent);
_uiRouter.$state;

_credit.$CreditDataModel;

_squid.$Class;

_squid.$Component;

_squid.$elmo;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$pxp;

_logger.$logger;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutPayeeModel;

_checkout.$FlowEligibilityModel;

_guestThrottle.$guestThrottle;

_paypalplus.$isPayPalPlus;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/onboarding/directive.js
// module id = ./pages/xo-login/onboarding/directive.js
// module chunks = main-code-split